export function removeQuerystring(url: string) {
    const updatedUrl = url.split("?")[0];
    return updatedUrl.endsWith("/") ? updatedUrl : `${updatedUrl}/`;
}

